<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="selectRange">
        <h3>예약조회</h3>
        <p>조회하실 날짜를 선택해 주세요.</p>
        <div class="datebtnWrap">
          <button type="button" class="direct active">직접입력</button>
          <button type="button" class="month">1개월</button>
          <button type="button" class="halfYear">6개월</button>
          <button type="button" class="whole">전체</button>
        </div>
      </div>
      <div class="searchListWrap">
        <h5 class="period">{{today}}<b>-</b>{{lastDayment}}</h5>
        <div class="inBtn pre">
          <router-link to="./researchDate">
        <button type="button" class="searcg function">조회</button>
          </router-link>
        </div>
        <div class="searchList">
          <div class="searchHeader">
            <div class="item"><p>진료과</p></div>
            <div class="item exception"><p>예약일시</p></div>
          </div>
          <div class="searchContent">
            <div class="list" v-for="(reservationItem, i) in GET_RESERVATION_LIST" :key="i">
              <div class="item">
                <p>{{reservationItem.doctorName}}</p>
              </div>
              <div class="item">
                <p>{{reservationItem.reservationDate | formatTimeList}}</p>
              </div>
              <div class="item">
                <div class="inBtn">
                  <button type="button">변경</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '예약조회',
        prevUrl: '/'
      },
      dataFlag: false,
      today: '',
      currentDaysSet: [],
      currentDayLast: '',
      lastDayment: ''
    }
  },
  computed: {
    ...mapGetters([
      'GET_RESERVATION_LIST'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  created () {
    this.getDefaultDate()
    this.fetchData()
  },
  filters: {
    formatTimeList: function (value) {
      value = value.toString()
      const date = value.substr(0, 10)
      const time = value.substr(11, 14)
      const target = date + '\n' + time
      return target
    }
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'FETCH_RESERVATION_LIST'
    ]),
    // 오늘과 마지막일짜를 구하는 함수
    getDefaultDate () {
      const existDate = []
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const dateMutated = new Date(year, month, 0)
      console.log('datedMutated', dateMutated)
      const lastDay = dateMutated.getDate()
      let monthValue
      let dayValue
      let transDate
      let today
      if (String(month).length < 2) {
        monthValue = '-0' + String(month)
      } else {
        monthValue = '-' + String(month)
      }
      if (String(day).length < 2) {
        dayValue = '-0' + String(day)
      } else {
        dayValue = '-' + String(day)
      }
      console.log('재료', String(year) + String(monthValue) + String(dayValue))
      const material = String(year) + monthValue + '-'
      const material2 = String(year) + monthValue + '-0'
      const repeatLength = day
      for (let i = 1; i < repeatLength + 1; i++) {
        if (i < 10) {
          transDate = material2 + i
        } else {
          transDate = material + i
        }
        existDate.push(transDate)
      }
      if (String(day).length < 2) {
        today = String(material2 + day)
      } else {
        today = String(material + day)
      }
      const lastDayment = String(material + lastDay)
      this.today = today
      this.currentDaysSet = existDate
      this.currentDayLast = lastDay
      this.lastDayment = lastDayment
    },
    // 예약조회를 실행함
    async fetchData () {
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            lte: this.lastDayment,
            gte: this.today,
            default: false
          }
        } else {
          requestData = {
            lte: this.lastDayment,
            gte: this.today,
            default: false
          }
        }
        await this.FETCH_RESERVATION_LIST(requestData)
          .then(() => this.carryData())
      } catch (error) {
        console.log('error :', error);
        console.log('예약조회 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    beforeDestroy () {
      this.SET_POPUP(false)
    },
    carryData () {
      console.log('ㅇ', this.GET_RESERVATION_LIST)
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
</style>
